import cn from 'classnames';
import { Link } from '@/ui-components/atoms/Link/Link';
import styles from './entityTileItem.module.scss';
import { ReactNode } from 'react';

const {
    mainWrapper,
    hoverStyles,
    imageInCardStyles,
    linkStyles,
    contentStyles,
    noLinkContentStyles,
    gradientBackground,
    copyright,
} = styles;

export interface EntityTileItemProps {
    children?: ReactNode;
    backgroundColor?: string;
    href?: string;
    ariaLabel?: string;
    image?: ReactNode;
    imageCopyright?: string;
    noLink?: boolean;
}

export function EntityTileItem({
    image,
    children,
    backgroundColor,
    href,
    ariaLabel,
    imageCopyright,
    noLink = false,
}: EntityTileItemProps) {
    const mainWrapperStyles = cn(mainWrapper, {
        [hoverStyles]: !noLink,
    });

    const linkStyling = cn(linkStyles, {
        [gradientBackground]: Boolean(children),
    });

    const noLinkStyles = cn(noLinkContentStyles, {
        [imageInCardStyles]: image,
    });

    return (
        <>
            <div className={mainWrapperStyles} style={backgroundColor ? { backgroundColor } : {}}>
                {image}
                {noLink ? (
                    children && (
                        <div className={noLinkStyles}>
                            <div className={contentStyles}>{children}</div>
                        </div>
                    )
                ) : (
                    <Link href={href} aria-label={ariaLabel} className={linkStyling}>
                        {children && <div className={contentStyles}>{children}</div>}
                    </Link>
                )}
            </div>
            {imageCopyright && <div className={copyright}>{imageCopyright}</div>}
        </>
    );
}
